import { Tag } from '@components';
import { useScreenSize } from '@hooks';
import { Flex, theme, Typography } from '@styles';
import { arrayOf, shape, string } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { capitalizeFirstLetter } from 'src/helpers';

import { cardLayoutByVariant } from './CourseDescriptionCard.layoutProps';

const CourseDescriptionCard = ({
  cardStyle,
  descriptionPoints,
  tagType,
  title,
}) => {
  const { i18n } = useTranslation();
  const { device, isTabletLG } = useScreenSize();
  const layout = cardLayoutByVariant[device || 'desktop'];

  const renderTag = () => {
    switch (tagType) {
      case 'knowledge':
        return (
          <Tag
            content={i18n.t('SoldierLevelPage.ResultDescription.Knowledge.Tag')}
            variant={tagType}
          />
        );
      case 'attitude':
        return (
          <Tag
            content={i18n.t('SoldierLevelPage.ResultDescription.Attitude.Tag')}
            variant={tagType}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Flex
      backdropFilter="blur(17px)"
      bg={theme.colors.white[10]}
      border={1}
      borderColor={theme.colors.white[10]}
      borderStyle="solid"
      flex={1 / 2}
      flexDirection="column"
      {...(!isTabletLG && { minHeight: 416 })}
      {...layout}
      {...cardStyle}
    >
      {tagType && renderTag()}
      <Typography color={theme.colors.white[100]} variant="BN-bold-s43-lh38">
        {title}
      </Typography>
      <ul style={{ paddingLeft: 16 }}>
        {descriptionPoints?.map((item) => (
          <li className="marker-60">
            <Typography
              color={theme.colors.white[60]}
              variant="MS-regular-s14-lh22"
            >
              {capitalizeFirstLetter(item)}
            </Typography>
          </li>
        ))}
      </ul>
    </Flex>
  );
};

CourseDescriptionCard.propTypes = {
  cardStyle: shape(),
  descriptionPoints: arrayOf(string),
  tagType: string,
  title: string.isRequired,
};

CourseDescriptionCard.defaultProps = {
  cardStyle: {},
  descriptionPoints: [],
  tagType: '',
};

export default CourseDescriptionCard;
